import React from 'react';

import { PeoStaffListQueryVariables, usePeoStaffListQuery } from 'src/api';

export const usePeoStaffList = (
  variables?: PeoStaffListQueryVariables,
  skip?: boolean,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = usePeoStaffListQuery({
    variables,
    skip,
    notifyOnNetworkStatusChange,
  });

  const peoStaffsList = React.useMemo(() => data?.peoStaffList ?? [], [data?.peoStaffList]);

  const peoStaffsCount = React.useMemo(() => data?.peoStaffCount ?? 0, [data?.peoStaffCount]);

  return {
    peoStaffsList,
    peoStaffsCount,
    refetch,
    loading,
  };
};
